module.exports = __webpack_public_path__ + "202222:4f4eb5d45eb7a9e97a70/img/info_image@1x.6f930c0.png";